import { IBackgroundJob } from '../types/IBackgroundJob';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetBackgroundJobsResult extends IGetItemsResult {
  backgroundJobs: IBackgroundJob[];
}

export class GetBackgroundJobsRequest extends Request<IGetItemsParams, IGetBackgroundJobsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobs', params);
  }
}
